module.exports = __webpack_public_path__ + "assets/img/video.3dd72da5.svg";